export default "__VITE_ASSET__C5Qd1ZA0__"